import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import styled from "styled-components";
import TableActionButton from "../../../../@ui/TableActionButton";
import TriggerImportModal from "../../../modal/LayerAdmin/OsPoi/TriggerImportModal";
import OsPoiService from "../../../../services/OsPoiService";

const StyledIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

interface TriggerImportProps {
  service: OsPoiService;
  onSubmitted: () => void;
}

const TriggerImport = ({ service, onSubmitted }: TriggerImportProps) => {
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errored, setErrored] = useState(false);

  const handleSubmit = (description?: string, file?: File | null) => {
    setSubmitting(true);
    if (file != null && description != null) {
      service.StartOsPoiImport(file, description).then(() => {
        setShow(false);
        onSubmitted();
      }).catch(() => {
        setErrored(true);
      });
    }
  };

  return (
    <div className="mr-1 w-100 text-end mb-1">
      <div>
        <TableActionButton onClick={() => setShow(true)}>
          <StyledIcon icon={faPlus} />
          Trigger Import
        </TableActionButton>
      </div>
      <TriggerImportModal
        onSubmit={handleSubmit}
        onClose={() => setShow(false)}
        show={show}
        isSubmitting={submitting}
        hasErrored={errored}
      />
    </div>
  );
};

export default TriggerImport;
